// Import de funcions auxiliars
import {
    obteVariable,
    obteValorVariable,
    afegeixErrorAVariable
}  from './utils';

/*
 * Per facilitar la lectura del codi s'afegeixen els identificadors de variables a mode de constants
 ***/
export const ID_TEMPERATURA_DEL_TERMOMETRE_SEC = 1;
export const ID_TEMPERATURA_DEL_TERMOMETRE_HUMIT = 2;
export const ID_HUMITAT_RELATIVA = 3;
export const ID_TEMPERATURA_MAXIMA = 4;
export const ID_TEMPERATURA_MINIMA = 6;

/*
 * Missatges d'error propis del grup
 ***/
export const MSG_TEMP_HUMIT_INFERIOR_O_IGUAL_TEMP_SEC = 'La temperatura del termòmetre humit ha de ser inferior o igual a la temperatura del termòmetre sec.';
export const MSG_TEMP_SEC_SUPERIOR_O_IGUAL_TEMP_HUMIT = 'La temperatura del termòmetre sec ha de ser superior o igual a la temperatura del termòmetre humit.';

export const MSG_SI_TEMP_HUMIT_IGUAL_TEMP_SEC_ALESHORES_HUMITAT_RELATIVA_100 = 'Si la temperatura del termòmetre humit és igual a la temperatura del termòmetre sec, la humitat relativa ha de ser del 100%.';

export const MSG_SI_HUMITAT_RELATIVA_100_ALESHORES_TEMP_HUMIT_IGUAL_TEMP_SEC = 'Si l\'humitat relativa és del 100%, la temperatura del termòmetre humit ha de ser igual a la temperatura del termòmetre sec.';

export const MSG_TEMP_MIN_INFERIOR_O_IGUAL_TEMP_SEC = 'La temperatura mínima ha de ser inferior o igual a la temperatura del termòmetre sec.';
export const MSG_TEMP_SEC_SUPERIOR_O_IGUAL_TEMP_MIN = 'La temperatura del termòmetre sec ha de ser superior o igual a la temperatura mínima.';

export const MSG_TEMP_MAX_SUPERIOR_O_IGUAL_TEMP_SEC = 'La temperatura màxima ha de ser superior o igual a la temperatura del termòmetre sec.';
export const MSG_TEMP_SEC_INFERIOR_O_IGUAL_TEMP_MAX = 'La temperatura del termòmetre sec ha de ser inferior o igual a la temperatura màxima.';

export const MSG_TEMP_MIN_INFERIOR_O_IGUAL_TEMP_MAX = 'La temperatura mínima ha de ser inferior o igual a la temperatura màxima.';
export const MSG_TEMP_MAX_SUPERIOR_O_IGUAL_TEMP_MIN = 'La temperatura màxima ha de ser superior o igual a la temperatura mínima.';

export const MSG_TEMP_MAX_OBLIGATORIA = 'La temperatura màxima és obligatòria.';

export const MSG_TEMP_MIN_OBLIGATORIA = 'La temperatura mínima és obligatòria.';

/*
 * Funcions que avaluen si es compleix la condició per afegir l'error
 ***/
const checkTempHumitSuperiorTempSec = (temperaturaDelTermometreHumitValor, temperaturaDelTermometreSecValor) => {
    return temperaturaDelTermometreHumitValor !== null && temperaturaDelTermometreSecValor !== null &&
        temperaturaDelTermometreHumitValor > temperaturaDelTermometreSecValor;
};

const checkSiTempHumitIgualTempSecLlavorsHumitat100 = (temperaturaDelTermometreHumitValor, temperaturaDelTermometreSecValor, humitatRelativaValor) => {
    return temperaturaDelTermometreHumitValor === temperaturaDelTermometreSecValor &&
        temperaturaDelTermometreHumitValor !== null && temperaturaDelTermometreSecValor !== null &&
        humitatRelativaValor !== 100;
};

const checkSiHumitat100TempHumitIgualTempSec = (temperaturaDelTermometreHumitValor, temperaturaDelTermometreSecValor, humitatRelativaValor) => {
    return humitatRelativaValor === 100 &&
        (temperaturaDelTermometreHumitValor === null || temperaturaDelTermometreSecValor === null ||
        temperaturaDelTermometreHumitValor !== temperaturaDelTermometreSecValor);
};

const checkTempMinSuperiorTempSec = (temperaturaMinimaValor, temperaturaDelTermometreSecValor) => {
    return temperaturaMinimaValor !== null && temperaturaDelTermometreSecValor !== null &&
        temperaturaMinimaValor > temperaturaDelTermometreSecValor;
};

const checkTempMaxInferiorTempSec = (temperaturaMaximaValor, temperaturaDelTermometreSecValor) => {
    return temperaturaMaximaValor !== null && temperaturaDelTermometreSecValor !== null &&
        temperaturaMaximaValor < temperaturaDelTermometreSecValor;
};

const checkTempMaxInferiorTempMin = (temperaturaMinimaValor, temperaturaMaximaValor) => {
    return temperaturaMinimaValor !== null && temperaturaMaximaValor !== null &&
        temperaturaMinimaValor > temperaturaMaximaValor;
};

const checkTempMinObligatoria = (temperaturaMinimaValor) => {
    return temperaturaMinimaValor !== 0 && !temperaturaMinimaValor;
};

const checkTempMaxObligatoria = (temperaturaMaximaValor) => {
    return temperaturaMaximaValor !== 0 && !temperaturaMaximaValor;
};

/*
 * Grup Temperatura, humitat i evaporació
 ***/
export const checkGrupTemperaturaHumitatEvaporacio = (nouVariables) => {

    // Variables
    const temperaturaDelTermometreSec = obteVariable(ID_TEMPERATURA_DEL_TERMOMETRE_SEC, nouVariables);
    const temperaturaDelTermometreHumit = obteVariable(ID_TEMPERATURA_DEL_TERMOMETRE_HUMIT, nouVariables);
    const humitatRelativa = obteVariable(ID_HUMITAT_RELATIVA, nouVariables);
    const temperaturaMinima = obteVariable(ID_TEMPERATURA_MINIMA, nouVariables);
    const temperaturaMaxima = obteVariable(ID_TEMPERATURA_MAXIMA, nouVariables);

    // Valors de variables
    const temperaturaDelTermometreSecValor = obteValorVariable(temperaturaDelTermometreSec);
    const temperaturaDelTermometreHumitValor = obteValorVariable(temperaturaDelTermometreHumit);
    const humitatRelativaValor = obteValorVariable(humitatRelativa);
    const temperaturaMinimaValor = obteValorVariable(temperaturaMinima);
    const temperaturaMaximaValor = obteValorVariable(temperaturaMaxima);

    if (temperaturaMinima) {
        // La variable TEMPERATURA_MINIMA és obligatòria
        if (checkTempMinObligatoria(temperaturaMinimaValor)) {
            afegeixErrorAVariable(temperaturaMinima, MSG_TEMP_MIN_OBLIGATORIA);
        }
    }

    if (temperaturaMinima && temperaturaDelTermometreSec) {
        // La TEMPERATURA_MINIMA ha de ser <= TEMPERATURA_DEL_TERMOMETRE_SEC
        if (checkTempMinSuperiorTempSec(temperaturaMinimaValor, temperaturaDelTermometreSecValor)) {
            afegeixErrorAVariable(temperaturaMinima, MSG_TEMP_MIN_INFERIOR_O_IGUAL_TEMP_SEC);
            afegeixErrorAVariable(temperaturaDelTermometreSec, MSG_TEMP_SEC_SUPERIOR_O_IGUAL_TEMP_MIN);
        }
    }

    if (temperaturaMaxima) {
        // La variable TEMPERATURA_MAXIMA és obligatòria
        if (checkTempMaxObligatoria(temperaturaMaximaValor)) {
            afegeixErrorAVariable(temperaturaMaxima, MSG_TEMP_MAX_OBLIGATORIA);
        }
    }

    if (temperaturaMaxima && temperaturaDelTermometreSec) {
        // La TEMPERATURA_MAXIMA ha de ser >= TEMPERATURA_DEL_TERMOMETRE_SEC
        if (checkTempMaxInferiorTempSec(temperaturaMaximaValor, temperaturaDelTermometreSecValor)) {
            afegeixErrorAVariable(temperaturaMaxima, MSG_TEMP_MAX_SUPERIOR_O_IGUAL_TEMP_SEC);
            afegeixErrorAVariable(temperaturaDelTermometreSec, MSG_TEMP_SEC_INFERIOR_O_IGUAL_TEMP_MAX);
        }
    }

    if (temperaturaMaxima && temperaturaMinima) {
        // La TEMPERATURA_MINIMA ha de ser <= TEMPERATURA_MAXIMA
        if (checkTempMaxInferiorTempMin(temperaturaMinimaValor, temperaturaMaximaValor)) {
            afegeixErrorAVariable(temperaturaMinima, MSG_TEMP_MIN_INFERIOR_O_IGUAL_TEMP_MAX);
            afegeixErrorAVariable(temperaturaMaxima, MSG_TEMP_MAX_SUPERIOR_O_IGUAL_TEMP_MIN);
        }
    }

    if (temperaturaDelTermometreSec && temperaturaDelTermometreHumit) {
        // La TEMPERATURA_DEL_TERMOMETRE_HUMIT ha de ser <= TEMPERATURA_DEL_TERMOMETRE_SEC
        if (checkTempHumitSuperiorTempSec(temperaturaDelTermometreHumitValor, temperaturaDelTermometreSecValor)) {
            afegeixErrorAVariable(temperaturaDelTermometreHumit, MSG_TEMP_HUMIT_INFERIOR_O_IGUAL_TEMP_SEC);
            afegeixErrorAVariable(temperaturaDelTermometreSec, MSG_TEMP_SEC_SUPERIOR_O_IGUAL_TEMP_HUMIT);
        }
    }

    if (temperaturaDelTermometreSec && temperaturaDelTermometreHumit && humitatRelativa) {
        // Si TEMPERATURA_DEL_TERMOMETRE_HUMIT === TEMPERATURA_DEL_TERMOMETRE_SEC, la HUMITAT_RELATIVA ha de ser del 100%
        if (checkSiTempHumitIgualTempSecLlavorsHumitat100(temperaturaDelTermometreHumitValor, temperaturaDelTermometreSecValor, humitatRelativaValor)) {
            afegeixErrorAVariable(humitatRelativa, MSG_SI_TEMP_HUMIT_IGUAL_TEMP_SEC_ALESHORES_HUMITAT_RELATIVA_100);
            afegeixErrorAVariable(temperaturaDelTermometreHumit, MSG_SI_TEMP_HUMIT_IGUAL_TEMP_SEC_ALESHORES_HUMITAT_RELATIVA_100);
            afegeixErrorAVariable(temperaturaDelTermometreSec, MSG_SI_TEMP_HUMIT_IGUAL_TEMP_SEC_ALESHORES_HUMITAT_RELATIVA_100);
        }

        // Si HUMITAT_RELATIVA és del 100%, TEMPERATURA_DEL_TERMOMETRE_HUMIT = TEMPERATURA_DEL_TERMOMETRE_SEC
        if (checkSiHumitat100TempHumitIgualTempSec(temperaturaDelTermometreHumitValor, temperaturaDelTermometreSecValor, humitatRelativaValor)) {
            afegeixErrorAVariable(humitatRelativa, MSG_SI_HUMITAT_RELATIVA_100_ALESHORES_TEMP_HUMIT_IGUAL_TEMP_SEC);
            afegeixErrorAVariable(temperaturaDelTermometreHumit, MSG_SI_HUMITAT_RELATIVA_100_ALESHORES_TEMP_HUMIT_IGUAL_TEMP_SEC);
            afegeixErrorAVariable(temperaturaDelTermometreSec, MSG_SI_HUMITAT_RELATIVA_100_ALESHORES_TEMP_HUMIT_IGUAL_TEMP_SEC);
        }
    }

};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/grupTemperaturaHumitatEvaporacio.js